



















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ITag } from '@/models';
import { ErrorManager } from '@/models/error';

// directly exposed from vuetify/types no intention to change
import { InputValidationRules } from 'vuetify/types';

export type TagPickerType = (number | ITag)[] | number | ITag;
export default Vue.extend({
  name: 'TagPicker',

  props: {
    value: [Array, Number, Object] as PropType<TagPickerType>,

    externalErrorMessage: {
      type: [String, Array] as PropType<string | string[]>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any, prevVal: any) {
        if (val !== prevVal) {
          this.lazyValue = val;
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      tags: 'itemTag/getTags'
    }),

    internalValue: {
      get(): TagPickerType {
        return this.lazyValue;
      },
      set(val: TagPickerType) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    genInternalMessages(): InputValidationRules {
      if (!this.externalErrorMessage) return [];
      else if (Array.isArray(this.externalErrorMessage))
        return this.externalErrorMessage;
      else return [this.externalErrorMessage];
    },

    errorMessageList(): InputValidationRules {
      const errorList = this.genInternalMessages;
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  methods: {
    ...mapActions({
      fetchTags: 'itemTag/fetchTags'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
    }
  },

  mounted() {
    this.loading = true;

    this.fetchTags()
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
});
